import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../common/constants';
import Error404 from '../Error404';
import CompanyWrapper from '../modules/company';
import UserWrapper from '../modules/users';

const ContentRoutes = () => {
  return (
    <>
      <Switch>
        <Route path={ROUTES.USERS_MANAGEMENT} component={UserWrapper} />
        <Route path={ROUTES.COMPANY} component={CompanyWrapper} />
        <Route path="*" exact component={Error404} />
      </Switch>
    </>
  );
};

export default ContentRoutes;
